import axios from 'axios'
import store from '@/store'
import endpoints from '@/utils/endpoints.js'

axios.defaults.baseURL = window
  ? window.VUE_APP_API_URL
  : process.env.VUE_APP_API_URL

axios.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response.config.url != endpoints.createTokenRefresh()) {
      store.commit('setLastActivity')
    }
    return response
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)

export default axios

export const anonymousAxios = axios.create({
  baseURL: axios.defaults.baseURL,
  headers: {}
})
